export enum BrandCode {
    Celebrity = 'C',
    RoyalCaribbean = 'R',
}

export enum BrandAlpha3Code {
    Celebrity = 'CEL',
    RoyalCaribbean = 'RCI',
}

export interface Brand {
    code: BrandCode,
    alpha3Code: BrandAlpha3Code,
}

